import { useEffect, useState, useRef } from "react";
import styles from "./Notification.module.css";
import { ReactComponent as ErrorIcon } from "../../assets/notificationIcons/exclamation.svg";
import { ReactComponent as WarningIcon } from "../../assets/notificationIcons/exclamation.svg";
import { ReactComponent as SuccessIcon } from "../../assets/notificationIcons/succsess.svg";

import { useNotificationStore } from "../../store/NotificationStore";

// import Reward from '../../components/Reward/Reward';

const Notification = () => {
  const [visible, setVisible] = useState(false);
  const [progress, setProgress] = useState(100);
  const progressRef = useRef<HTMLDivElement>(null);
  const message = useNotificationStore((state) => state.notification.message);
  const type = useNotificationStore((state) => state.notification.type);
  //   const rewards = useNotificationStore((state) => state.notification.rewards);
  const duration = useNotificationStore((state) => state.notification.duration);
  const closeNotification = useNotificationStore(
    (state) => state.closeNotification,
  );
  const showNotification = useNotificationStore(
    (state) => state.showNotification,
  );
  const tg = window.Telegram?.WebApp;

  // useEffect(() => {
  //   if (tg && tg.HapticFeedback && message) {
  //     if (type === 'Error') {
  //       tg.HapticFeedback.notificationOccurred('error');
  //     } else if (type === 'Warning') {
  //       tg.HapticFeedback.notificationOccurred('warning');
  //     } else {
  //       tg.HapticFeedback.notificationOccurred('success');
  //     }
  //   } else {
  //     console.warn('Telegram WebApp or HapticFeedback is not available');
  //   }
  // }, [type]);

  useEffect(() => {
    if (showNotification) {
      setVisible(true);
      setProgress(100);

      // Запускаем анимацию прогресса
      const startTime = Date.now();
      const animationDuration = duration || 3000; // Используем кастомную длительность или 3 секунды по умолчанию

      const updateProgress = () => {
        const elapsed = Date.now() - startTime;
        const progress = Math.min(1, elapsed / animationDuration);

        // Равномерная анимация
        const newProgress = Math.max(0, 100 - progress * 100);

        setProgress(newProgress);

        if (progress < 1) {
          requestAnimationFrame(updateProgress);
        }
      };

      requestAnimationFrame(updateProgress);
    } else if (!showNotification && visible) {
      const timer = setTimeout(() => {
        setVisible(false);
      }, 500); // Длительность анимации исчезновения
      return () => clearTimeout(timer);
    }
  }, [showNotification, visible]);

  // Обновляю логику применения классов анимации
  const notificationClass = `${styles.notification}`;

  return (
    showNotification && (
      <div className={notificationClass}>
        <div className={styles.containerWrapper}>
          {/* <div
            className={
              type === 'Error'
                ? styles.blurCircleError
                : type === 'Warning'
                ? styles.blurCircleWarning
                : styles.blurCircleSuccess
            }
          ></div> */}
          <div className={styles.icon}>
            {type === "Error" ? (
              <ErrorIcon className={styles.iconImage} />
            ) : type === "Warning" ? (
              <WarningIcon className={styles.iconImage} />
            ) : (
              <SuccessIcon className={styles.iconImage} />
            )}
          </div>
          <div className={styles.message}>
            <div
              className={
                type === "Error"
                  ? styles.errorText
                  : type === "Warning"
                    ? styles.warningText
                    : styles.successText
              }
            >
              {message}
            </div>
            {/* {rewards && (
              <div className={styles.reward}>
                {rewards.map((reward) => (
                  <Reward reward={reward.amount} />
                ))}
              </div>
            )} */}
          </div>
          <div
            onClick={() => {
              console.log("clicked");
              closeNotification();
            }}
            className={styles.closeButton}
          ></div>
          <div className={styles.progressBar}>
            <div
              ref={progressRef}
              className={`${styles.progressFill} ${
                type === "Error"
                  ? styles.progressError
                  : type === "Warning"
                    ? styles.progressWarning
                    : styles.progressSuccess
              }`}
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>
      </div>
    )
  );
};

export default Notification;
